export default __webpack_public_path__ + "static/media/led_megakuningan.72147183.png";